import {Component, Input, ViewChild} from '@angular/core';
import {ManagementPortalAppComponent} from '../management-portal-app.component';
import {AuthenticationService} from '../../../../../common/_services/authentication.service';
import {User} from '../../../../../common/_models';
import {NotificationService} from '../../../../../common/_services/notification.service';

@Component({
    selector: 'app-details',
    templateUrl: './app-details.component.html',
    styleUrls: [
        './app-details.component.scss'
    ]
})
export class AppDetailsComponent {
    @Input() show: boolean;

    @ViewChild('buttonElement') buttonElement: HTMLButtonElement;
    @ViewChild('apiCopy') apiCopy: any;

    user: User;

    constructor(
        public parent: ManagementPortalAppComponent,
        authService: AuthenticationService,
        private notify: NotificationService
    ) {
        this.user = authService.currentUserValue;
    }

    hide() {
        this.show = false;
    }

    copyApiKey() {
        navigator.clipboard.writeText(this.user.accessToken)
            .then(data => {
                this.notify.success('Copied');
            })
            .catch(error => {
                this.notify.error(`Failed to copy to clipboard: ${error}`);
            });
    }
}

